//#region src/utils/logLevels.ts
let LogLevel = /* @__PURE__ */ function(LogLevel) {
	LogLevel["TRACE"] = "trace";
	LogLevel["DEBUG"] = "debug";
	LogLevel["INFO"] = "info";
	LogLevel["LOG"] = "log";
	LogLevel["WARN"] = "warn";
	LogLevel["ERROR"] = "error";
	return LogLevel;
}({});
const defaultLogLevel = "log";
const allLogLevels = [
	"trace",
	"debug",
	"info",
	"log",
	"warn",
	"error"
];
//#endregion
export { LogLevel, allLogLevels, defaultLogLevel };

//# sourceMappingURL=logLevels.js.map